import { Validators } from '@angular/forms';
import { IColumnConfigTableResponsive } from 'src/app/domain/IColumnConfigTableResponsive';
import { FieldTypeEnum } from 'src/app/domain/registration/enums/field-type.enum';
import { SystemTypeEnum } from 'src/app/domain/registration/enums/system-type.enum';
import { TableResponsiveTypeColumnEnum } from 'src/app/domain/registration/enums/table-responsive-type-column.enum';
import { TypeComponentFieldEnum } from 'src/app/domain/registration/enums/type-component-dynamic.enum';

export const RELATIVE_URL = 'systems';
export const COLUMNS_TO_SHOW_WEB = ['select', 'image', 'name', 'type', 'email', 'dueDate', 'createdAt', 'actions'];
export const COLUMNS_TO_SHOW_MOBILE = COLUMNS_TO_SHOW_WEB;
export const TABLE_CONFIG_COLUMNS: IColumnConfigTableResponsive[] = [
  {
    link_show: true,
    field_type: FieldTypeEnum.IMAGE,
    property: 'image',
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE} image-size`,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'type',
    display: 'TIPO',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'name',
    display: 'NOME',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'email',
    display: 'EMAIL',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    property: 'dueDate',
    display: 'VENCIMENTO',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    property: 'createdAt',
    display: 'CRIADO EM',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    property: 'parentSystem',
    display: 'SISTEMA PAI',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },

];

export const CES_CONFIG_FIELDS = [
  {
    type: TypeComponentFieldEnum.HIDDEN,
    name: 'id',
  },
  {
    name: 'image',
    type: TypeComponentFieldEnum.IMAGE,
  },
  {
    type: TypeComponentFieldEnum.SELECT,
    label: 'TIPO',
    name: 'type',
    options: Object.values(SystemTypeEnum),
    placeholder: 'Selecione uma opção',
    validation: [Validators.required],
  },
  {
    type: TypeComponentFieldEnum.INPUT,
    label: 'NOME',
    name: 'name',
    placeholder: 'Insira o nome',
    validation: [Validators.required, Validators.minLength(4)],
  },
  {
    type: TypeComponentFieldEnum.INPUT,
    label: 'EMAIL',
    name: 'email',
    placeholder: 'Insira o email',
    validation: [Validators.email],
  },
  {
    type: TypeComponentFieldEnum.SELECT,
    label: 'VENCIMENTO',
    name: 'dueDate',
    placeholder: 'Selecione o vencimento',
    validation: [Validators.required],
    options: [5, 10, 15, 20, 28],
  },
  {
    type: TypeComponentFieldEnum.SELECT_CRUD,
    label: 'SISTEMA PAI',
    name: 'parentSystem',
    value: 'name',
    defaultValue: ' ',
    options: [Object.values([])],
    placeholder: 'Selecione o sistema pai',
    validation: [Validators.required],
    hideSelectedValue: true
  },
  {
    type: TypeComponentFieldEnum.HIDDEN,
    name: 'contractTemplateUrl',
  },
  {
    type: TypeComponentFieldEnum.HIDDEN,
    name: 'contractTemplateName',
  },
  {
    type: TypeComponentFieldEnum.HIDDEN,
    name: 'contractTemplateType',
  },
  {
    type: TypeComponentFieldEnum.INPUT_FILE,
    label: 'ANEXAR ARQUIVO',
    name: 'contractTemplate',
    placeholder: 'Arraste e solte ou clique para selecionar o arquivo',
    accept: '.doc,.docx,.pdf',
    validation: [Validators.required],
  },
  {
    labelSave: 'Salvar',
    labelCancel: 'Cancelar',
    name: 'cancelSave',
    type: TypeComponentFieldEnum.CANCEL_SAVE,
  },
];
